import { Route } from "react-router-dom";
import { ShowProvider } from "../../../providers";
import { AppIconPage } from "../AppIconPage/AppIconPage";

const appIconRoutes = [
  <Route
    key={"app-icon"}
    path="app-icon"
    element={
      <ShowProvider>
        <AppIconPage />
      </ShowProvider>
    }
  />,
];

export const APP_ICON_ROUTES = appIconRoutes.map((route) => route);
